
export enum AppRoute {
  Products = 0,
  UsefulLinks = 1,
  Favorites = 2,
  About = 3,
  AI = 4,
  AdminArea = 5
}

export interface IAppPath {
  Route: AppRoute;
  Icon?: string;
  IconSrc?: string;
  Label: string;
  ExcelOnly?: boolean;
  Subtitle: string;
  Description?: string;
}
